export default __webpack_public_path__ + "static/app-features-2--mobile-f958ce890a4d01f763f57cf2315a52ae.webp";